import React, { Component } from 'react'
import PropTypes from "prop-types"
import ColName from './ColName'
import ColNumberBatches from './ColNumberBatches'
import ColActions from './ColActions'
import ColDateCreated from './ColDateCreated'
import ColTypePartner from "./ColTypePartner"
import ColReceiver from "./ColReceiver"
import {Checkbox} from 'antd'

class PartnerRow extends Component {
    constructor(props) {
        super(props)
        this.state = {
            expandedRows: {},
            toggleableRows: {},
        }
        this.groupRefs = {}
        this.COLLAPSED_MAX_HEIGHT = 63
    }

    componentDidMount() {
        this.updateToggleableRows()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.partners !== this.props.partners) {
            this.updateToggleableRows()
        }
    }

    toggleShowMore = (id, e) => {
        e.preventDefault()
        this.setState(prevState => ({
            expandedRows: {
                ...prevState.expandedRows,
                [id]: !prevState.expandedRows[id]
            }
        }))
    }

    updateToggleableRows = () => {
        const toggleableRows = {}
        this.props.partners.forEach(item => {
            if (!this.groupRefs[item._id]) {
                this.groupRefs[item._id] = React.createRef()
            }
            const container = this.groupRefs[item._id].current
            if (container) {
                toggleableRows[item._id] = container.scrollHeight > this.COLLAPSED_MAX_HEIGHT
            }
        })
        this.setState({ toggleableRows })
    }

    toggleShowMore = (id, e) => {
        e.preventDefault()
        this.setState(prevState => ({
            expandedRows: {
                ...prevState.expandedRows,
                [id]: !prevState.expandedRows[id]
            }
        }))
    }

    _detectChecked = (itemId) => {
        const { listSelected } = this.props
        return listSelected.includes(itemId)
    }

    _handleChange = (itemId) => {
        const { updateSelectedOrders } = this.props
        const isChecked = this._detectChecked(itemId)

        updateSelectedOrders(itemId, !isChecked)
    }

    render() {
        const { partners, partnerURL, reset, loadingAction } = this.props
        const { expandedRows, toggleableRows } = this.state

        return partners.map(item => {
            const { groups = [], has_groups, hidden } = item
            // Đảm bảo ref đã được tạo cho row này
            if (!this.groupRefs[item._id]) {
                this.groupRefs[item._id] = React.createRef()
            }
            const isExpanded = expandedRows[item._id]
            
            return <tr key={item._id} className={`${hidden ? 'partner-hidden' : 'partner-visible'}`}>
                <td className='OrderCheckbox'>
                    <Checkbox disabled={loadingAction} onChange={() => this._handleChange(item._id)} checked={this._detectChecked(item._id)} />
                </td>
                <ColName item={item} />
                <td>
                    {has_groups && groups.length > 0 ? (
                        <div className="group-container-wrapper">
                            <div
                                className={`group-list-container ${isExpanded ? 'expanded' : 'collapsed'}`}
                                ref={this.groupRefs[item._id]}
                            >
                                {groups.map(i => i.name).join(', ')}
                            </div>
                            <div className='float-right'>
                                {(toggleableRows[item._id] || isExpanded) && (
                                    <a
                                        href=''
                                        onClick={(e) => this.toggleShowMore(item._id, e)}
                                        className="toggle-button"
                                    >
                                        {isExpanded ? 'Thu gọn' : 'Xem thêm'}
                                    </a>
                                )}
                            </div>
                        </div>
                    ) : ''}
                </td>
                <ColTypePartner type={item.type_partner} />
                <ColReceiver type={item.type_partner} value={item.receiver_name} />
                <ColReceiver type={item.type_partner} value={item.receiver_phone} />
                <ColDateCreated created={item.created_at} />
                <ColNumberBatches item={item} />
                <ColActions code={item.code} partnerURL={partnerURL} reset={reset} item={item} />
            </tr>
        })
    }
}

PartnerRow.propTypes = {
    partners: PropTypes.array.isRequired,
    partnerURL: PropTypes.string,
}

export default PartnerRow